module.exports = __webpack_public_path__ + "static/media/linkedIn-icon.d10eed31.svg";